import {environment} from '../../../environments/environment';

export interface HowWork {
  id: number;
  type: string;
  title: string;
  text: string;
  lang: string;
  orden: number;
  video: string | null;
  picture: string | null;
  apartment_id: number;
  created_at: string;
  updated_at: string;
}

export interface HowWorksData {
  es: HowWork[];
  en: HowWork[];
  fr: HowWork[];
  [key: string]: HowWork[];
}

export interface HowWorks {
  data: HowWorksData;
}

function getHowWorksByLanguage(
  howWorks: HowWorks,
  lang: string,
  fallback: string = environment.defaultAppLang
): HowWork[] {
  const data = howWorks.data;
  const worksByLang = data[lang as keyof HowWorksData] || data[fallback as keyof HowWorksData] || [];
  return worksByLang.sort((a: HowWork, b: HowWork) => (a.orden || 0) - (b.orden || 0));
}

export function getHowWorks(howWorks: HowWorks): HowWork[] {
  return getHowWorksByLanguage(howWorks, environment.defaultAppLang);
}
